import * as React from "react";
import { Field } from "redux-form";

import { TextInput } from "../../../components";
import { ProjectInfoFormProps } from "./ProjectInfoForm";

const PageNumberField = (props: ProjectInfoFormProps) =>
  <div className="form-group">
    <label className="control-label col-md-4">Số lượng</label>
    <div className="col-md-8">
      <label>
        <Field
          className="form-control form-control-inline"
          type="number"
          name="page_number"
          min={1}
          component={TextInput}
        />
        {props.quantityUnit}
      </label>
    </div>
  </div>;

export default PageNumberField;



// WEBPACK FOOTER //
// ./src/routes/Step4/components/PageNumberField.tsx